import { buildModalViewDisplayedPayload } from './helpers/buildModalViewDisplayedPayload.js';
export const trackModalView = (params) => {
    return buildModalViewDisplayedPayload(params);
};
//# sourceMappingURL=trackModalView.js.map